import { Spacing } from "types/Spacing";

export const COLUMNS = ["Event", "", "Date", ""];
export const COLUMN_GAP: Spacing = "x-large";
export const COLUMN_ORDER = "minmax(12rem, 6fr) 11rem 2fr 11rem";

export const ITEMS_LIMIT = 50;
